/**
 * Processes form input by updating field value and triggering validation
 * @param updateFn - Function to update the field value
 * @param validateFn - Function to trigger field validation
 * @param fieldName - Name of the form field
 * @param value - New value for the field
 */
export default function processInput(
  updateFn: (fieldName: string, value: unknown) => void,
  validateFn: (fieldName: string) => void,
  fieldName: string,
  value: unknown,
): void {
  try {
    updateFn(fieldName, value);
    validateFn(fieldName);
  } catch (error) {
    console.error(`Error processing input for field ${fieldName}:`, error);
  }
}
